import { mapGetters, mapActions } from 'vuex'
import ClientType from '@/helper/ClientType'
import * as UserType from '@/helper/UserType'
import {
  ChangePassword,
  ConfirmLogout,
  ChooseTheme
} from '@/components'

import {
  UserAllowedOptions,
  Logout
} from '@/mixins'

export default {
  mixins: [
    UserAllowedOptions,
    Logout
  ],
  components: {
    ChangePassword,
    ConfirmLogout,
    ChooseTheme
  },
  computed: {
    ...mapGetters([
      'getterAccount'
    ])
  },
  data () {
    return {
      userType: UserType,
      clientType: ClientType,
      managerChooseTheme: false,
      managerDialogPassword: false,
      managerConfirmLogout: false,
      drawer: null,
      isLoading: false,
      valid: false,
      password: '',
      confirmPassword: '',
      msg: ''
    }
  },
  props: {
    source: String
  },
  mounted () {
    this.checkHasThemeSelected()
  },
  methods: {
    ...mapActions([
      'actionGetClientCredit'
    ]),
    checkHasThemeSelected () {
      setTimeout(() => {
        if (document.cookie.indexOf('DARK_THEME') === -1 && document.cookie.indexOf('LIGHT_THEME') === -1) {
          this.managerChooseTheme = true
        } else {
          this.managerChooseTheme = false
        }
      }, 200)
    },
    onClickOptionMenu (item) {
      if (item.routeName) {
        this.$router.push({ name: item.routeName })
      }

      if (item.action) {
        this[item.action](item)
      }
    },
    changeTheme () {
      this.managerChooseTheme = true
    },
    changePassword () {
      this.managerDialogPassword = true
    },
    onClickToLogout () {
      this.managerConfirmLogout = true
    },
    getClientCredit () {
      this.isLoading = true

      this.actionGetClientCredit(this.getterAccount)
        .then(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Dados do cliente selecionado atualizados com sucesso',
            type: 'success'
          })
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao atualizar os dados do cliente selecionado',
            type: 'danger'
          })
        })
    }
  },
  onIdle () {
    this.logout()
  }
}
